import React from 'react'
import PropTypes from 'prop-types'
import { ArtistPageTemplate } from '../../templates/artist-page'

const ArtistPagePreview = ({ entry, widgetFor }) => (
  <ArtistPageTemplate
    name={entry.getIn(['data', 'name'])}
    content={widgetFor('body')}
  />
)

ArtistPagePreview.propTypes = {
  entry: PropTypes.shape({
    getIn: PropTypes.func,
  }),
  widgetFor: PropTypes.func,
}

export default ArtistPagePreview
